module.exports = __webpack_public_path__ + "static/comwire-8365885e8b5d897838876aad1954a028.jpg";